import { Injectable } from '@angular/core';

import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class CampHoursUtilsService {
  static DEFAULT_CAMP_HOURS_MESSAGE = 'Contact Camp for operating hours';
  static DEFAULT_CAMP_HOURS = {
    monday: [CampHoursUtilsService.DEFAULT_CAMP_HOURS_MESSAGE],
    tuesday: [CampHoursUtilsService.DEFAULT_CAMP_HOURS_MESSAGE],
    wednesday: [CampHoursUtilsService.DEFAULT_CAMP_HOURS_MESSAGE],
    thursday: [CampHoursUtilsService.DEFAULT_CAMP_HOURS_MESSAGE],
    friday: [CampHoursUtilsService.DEFAULT_CAMP_HOURS_MESSAGE],
    saturday: [CampHoursUtilsService.DEFAULT_CAMP_HOURS_MESSAGE],
    sunday: [CampHoursUtilsService.DEFAULT_CAMP_HOURS_MESSAGE],
  };

  constructor() {}

  buildCampHoursDisplayInfo(hoursOfOperationJson) {
    const parsedCampHours = {};
    for (const day in hoursOfOperationJson) {
      // Only keep the "meaningful" data entry
      if (
        day !== '__typename' &&
        hoursOfOperationJson[day] !== 'Closed' &&
        hoursOfOperationJson[day] !== 'HoursOfOperation'
      ) {
        parsedCampHours[day] = this._parseHoursInfo(hoursOfOperationJson[day]);
      }
    }

    // Combine the "camp hours" info with the "defaults"
    const finalCampHours = {
      ...CampHoursUtilsService.DEFAULT_CAMP_HOURS,
      ...parsedCampHours,
    };
    return Object.keys(finalCampHours).map((day) => {
      // Build with format
      return {
        day: day,
        times: finalCampHours[day],
      };
    });
  }

  /**
   * Parse the "hours info" string and convert it into a list of "hours periods".
   *
   * For example:
   * - `06:30|19:00` will be `6:30 AM - 7:00 PM`.
   * - `07:00|10:00,16:00|19:00` will have 2 period entries - `7:00 AM - 10:00 AM` and `4:00 PM - 7:00 PM`.
   *
   * @param info
   * @returns
   */
  private _parseHoursInfo(hoursInfo: string): string[] {
    const hoursOutputs = [];

    const hoursInfoEntries = hoursInfo.split(',');
    hoursInfoEntries.map((entry: string) => {
      const rangeEntries = entry.split('|');
      if (Array.isArray(rangeEntries) && rangeEntries.length === 2) {
        hoursOutputs.push(
          `${moment(rangeEntries[0], 'HH:mm').format('h:mm A')} - ${moment(
            rangeEntries[1],
            'HH:mm'
          ).format('h:mm A')}`
        );
      }
    });

    return hoursOutputs;
  }
}
